import type { BrandJson } from "@coras-io/brand-tokens";
import {
  DEFAULT_CURRENCIES,
  DEFAULT_LOCALES,
  type SiteConfig,
} from "../../src/types";
import { MILES_AND_MORE } from "../../src/loyalty/miles-and-more";
import brandConfig from "./brand.json";

export const brand = brandConfig as BrandJson;

export const site: SiteConfig = {
  distributorId: "cf582973-7f62-4818-b610-a520d403b524",
  title: "Brussels Airlines",
  description: "Book tickets to West End Shows, Concerts and more",
  locale: "en-GB",
  currency: "EUR",
  locales: DEFAULT_LOCALES,
  currencies: DEFAULT_CURRENCIES,
  favicons: ["favicon.png"],
  logo: "/assets/images/logo.svg",
  domain: "brusselsairlines.coras.io",
  detectLocale: true,
  detectCurrency: true,
  linkedTravelNotice: {
    company: "Brussels Airlines SA/NV",
    companyPossessive: "Brussels Airlines'",
    insolvencyProtectionUrl: {
      default:
        "https://www.brusselsairlines.com/en-be/misc/insolvency-protection.aspx",
    },
  },
  loyalty: MILES_AND_MORE,
};
